import {
  EQUIPMENT_STOCK_DETAIL_ITEM_LIST, 
  EQUIPMENT_STOCK_DETAIL_ITEM_LIST_SUCCESS, 
  EQUIPMENT_STOCK_DETAIL_ITEM_LIST_ERROR,
  EQUIPMENT_STOCK_DETAIL_ITEM_SEARCH_SET, 
  EQUIPMENT_STOCK_DETAIL_ITEM_SEARCH_CHANGE, 
  EQUIPMENT_STOCK_DETAIL_ITEM_PAGE_SET,
  EQUIPMENT_STOCK_DETAIL_ITEM_SEARCH_EQUIPMENT_STOCK_DETAIL,
  EQUIPMENT_STOCK_DETAIL_ITEM_SEARCH_EQUIPMENT_STOCK_DETAIL_SUCCESS,
  EQUIPMENT_STOCK_DETAIL_ITEM_SEARCH_EQUIPMENT_STOCK_DETAIL_ERROR,
  EQUIPMENT_STOCK_DETAIL_ITEM_SEARCH_OPERATION_STATUS,
  EQUIPMENT_STOCK_DETAIL_ITEM_SEARCH_OPERATION_STATUS_SUCCESS,
  EQUIPMENT_STOCK_DETAIL_ITEM_SEARCH_OPERATION_STATUS_ERROR, 
  EQUIPMENT_STOCK_DETAIL_ITEM_SEARCH_APPLY_OPTION,
  EQUIPMENT_STOCK_DETAIL_ITEM_SEARCH_APPLY_OPTION_SUCCESS,
  EQUIPMENT_STOCK_DETAIL_ITEM_SEARCH_APPLY_OPTION_ERROR, 
  EQUIPMENT_STOCK_DETAIL_ITEM_SEARCH_EQUIPMENT_FILE,
  EQUIPMENT_STOCK_DETAIL_ITEM_SEARCH_EQUIPMENT_FILE_SUCCESS,
  EQUIPMENT_STOCK_DETAIL_ITEM_SEARCH_EQUIPMENT_FILE_ERROR,
  EQUIPMENT_STOCK_DETAIL_ITEM_SEARCH_ACQUISITION_MODE,
  EQUIPMENT_STOCK_DETAIL_ITEM_SEARCH_ACQUISITION_MODE_SUCCESS,
  EQUIPMENT_STOCK_DETAIL_ITEM_SEARCH_ACQUISITION_MODE_ERROR,
  EQUIPMENT_STOCK_DETAIL_ITEM_SEARCH_INSTALLATION_CONDITION,
  EQUIPMENT_STOCK_DETAIL_ITEM_SEARCH_INSTALLATION_CONDITION_SUCCESS,
  EQUIPMENT_STOCK_DETAIL_ITEM_SEARCH_INSTALLATION_CONDITION_ERROR,
  EQUIPMENT_STOCK_DETAIL_ITEM_SEARCH_SERVICE_TYPE,
  EQUIPMENT_STOCK_DETAIL_ITEM_SEARCH_SERVICE_TYPE_SUCCESS,
  EQUIPMENT_STOCK_DETAIL_ITEM_SEARCH_SERVICE_TYPE_ERROR,
  EQUIPMENT_STOCK_DETAIL_ITEM_ADD_SET,
  EQUIPMENT_STOCK_DETAIL_ITEM_ADD_MODAL_SET,
  EQUIPMENT_STOCK_DETAIL_ITEM_ADD,
  EQUIPMENT_STOCK_DETAIL_ITEM_ADD_SUCCESS,
  EQUIPMENT_STOCK_DETAIL_ITEM_ADD_ERROR,
  EQUIPMENT_STOCK_DETAIL_ITEM_ADD_CHANGE,
  EQUIPMENT_STOCK_DETAIL_ITEM_DETAIL,
  EQUIPMENT_STOCK_DETAIL_ITEM_DETAIL_SUCCESS,
  EQUIPMENT_STOCK_DETAIL_ITEM_DETAIL_ERROR,
  EQUIPMENT_STOCK_DETAIL_ITEM_VIEW_MODAL_SET,
  EQUIPMENT_STOCK_DETAIL_ITEM_EDIT_CHANGE,
  EQUIPMENT_STOCK_DETAIL_ITEM_EDIT_MODAL_SET,
  EQUIPMENT_STOCK_DETAIL_ITEM_UPDATE,
  EQUIPMENT_STOCK_DETAIL_ITEM_UPDATE_SUCCESS,
  EQUIPMENT_STOCK_DETAIL_ITEM_UPDATE_ERROR,
  EQUIPMENT_STOCK_DETAIL_ITEM_VIEW_TAB_SET
} from '../../actions';
 
const INIT_STATE = {
  loading: true,
  file: [],
  list: {
    header:{
      name: 'code',
      order:'sorted-asc'
    },
    page:{
      current: 1,
      rows: 1000
    }
  },
  add: {
    data: {
      new:{ id_service_type: null, service_type: null, id_installation_condition: null, installation_condition: null, id_acquisition_mode: null, acquisition_mode: null, id_equipment_file: null, equipment_file: null, id_equipment_stock_detail: null, equipment_stock_detail: null, id_operation_status: null, operation_status: null, id_apply_option: null, apply_option: null, reference: '', observation: '', description: ''}
    },
    modal: false,
    loading: false,
    message: '',
    url: '',
    type: ''
  },
  error: false,
  search:{
    modal: false,
    init:true,
    data:{
      equipment_stock_detail: false,
      operation_status: false,
      apply_option: false,
      equipment_file: false,
      acquisition_mode: false,
      installation_condition: false,
      service_type: false
    },
    value:{
      equipment_stock_detail: false,
      operation_status: false,
      apply_option: false,
      equipment_file: false,
      acquisition_mode: false,
      installation_condition: false,
      service_type: false
    },
    service_type:{
      loading: true,
      list:[],
      message: ''
    },
    installation_condition:{
      loading: true,
      list:[],
      message: ''
    },
    acquisition_mode:{
      loading: true,
      list:[],
      message: ''
    },
    equipment_file:{
      loading: true,
      list:[],
      message: ''
    },
    equipment_stock_detail:{
      loading: true,
      list:[],
      message: ''
    },
    operation_status:{
      loading: true,
      list:[],
      message: ''
    },
    apply_option:{
      loading: true,
      list:[],
      message: ''
    }
  },
  detail: {
    data: [],
    tab: 'general',
    loading: true,
  },
  view: {
    loading: true,
    data: [],
    tab: 'general',
    modal: false,
    log: {
      data: [],
      loading: false,
    },
  },
  edit: {
    loading: true,
    data: {
        new: [],
        old: []
    },
    list: {
        status: {
            data: [],
            loading: false,
        }
    },
    modal: false,
    update: {
        loading: false,
        response: '',
        message: ''
    }
  }
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case EQUIPMENT_STOCK_DETAIL_ITEM_LIST:
      return {
        ...state,
        loading: true,
        list: {
          ...state.list
        }
        
      }
    case EQUIPMENT_STOCK_DETAIL_ITEM_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        list: {
          ...state.list,
          ...action.payload
        } 
      }
    case EQUIPMENT_STOCK_DETAIL_ITEM_LIST_ERROR:
      return {
        ...state,
        loading: false,
        error: true
      }
    case EQUIPMENT_STOCK_DETAIL_ITEM_SEARCH_SET:
      return {
        ...state,
        search:{
          ...state.search,
          data: action.payload,
        }
      }
    case EQUIPMENT_STOCK_DETAIL_ITEM_SEARCH_CHANGE:
      return {
        ...state,
        search:{
          ...state.search,
          value: action.payload,
        }
      }
    case EQUIPMENT_STOCK_DETAIL_ITEM_PAGE_SET:
      return {
        ...state,
        list: {
          ...state.list,
          page: {
            ...state.list.page,
            ... action.payload,
          }
        },
        log: []
      }
    case EQUIPMENT_STOCK_DETAIL_ITEM_SEARCH_EQUIPMENT_STOCK_DETAIL:
      return {
        ...state,
        search:{
          ...state.search,
          init:false,
          equipment_stock_detail:{
            ...state.search.equipment_stock_detail,
            loading: true,
            list:[],
            message: ''
          }
        }
      }
    case EQUIPMENT_STOCK_DETAIL_ITEM_SEARCH_EQUIPMENT_STOCK_DETAIL_SUCCESS:
      return {
        ...state,
        search:{
          ...state.search,
          equipment_stock_detail:{
            ...state.search.equipment_stock_detail,
            loading: false,
            list: action.payload,
            message: ''
          }
        }
      }
    case EQUIPMENT_STOCK_DETAIL_ITEM_SEARCH_EQUIPMENT_STOCK_DETAIL_ERROR:
      return {
        ...state,
        search:{
          ...state.search,
          equipment_stock_detail:{
            ...state.search.equipment_stock_detail,
            loading: false,
            list:[],
            message: 'No se encotraron datos'
          }
        }
      }
    case EQUIPMENT_STOCK_DETAIL_ITEM_SEARCH_OPERATION_STATUS:
      return {
        ...state,
        search:{
          ...state.search,
          init:false,
          operation_status:{
            ...state.search.operation_status,
            loading: true,
            message: ''
          }
        }
      }
    case EQUIPMENT_STOCK_DETAIL_ITEM_SEARCH_OPERATION_STATUS_SUCCESS:
      return {
        ...state,
        search:{
          ...state.search,
          operation_status:{
            ...state.search.operation_status,
            loading: false,
            list: action.payload,
            message: ''
          }
        }
      }
    case EQUIPMENT_STOCK_DETAIL_ITEM_SEARCH_OPERATION_STATUS_ERROR:
      return {
        ...state,
        search:{
          ...state.search,
          operation_status:{
            ...state.search.operation_status,
            loading: false,
            list:[],
            message: 'No se encotraron datos'
          }
        }
      }
    case EQUIPMENT_STOCK_DETAIL_ITEM_SEARCH_APPLY_OPTION:
      return {
        ...state,
        search:{
          ...state.search,
          init:false,
          apply_option:{
            ...state.search.apply_option,
            loading: true,
            list:[],
            message: ''
          }
        }
      }
    case EQUIPMENT_STOCK_DETAIL_ITEM_SEARCH_APPLY_OPTION_SUCCESS:
      return {
        ...state,
        search:{
          ...state.search,
          apply_option:{
            ...state.search.apply_option,
            loading: false,
            list: action.payload,
            message: ''
          }
        }
      }
    case EQUIPMENT_STOCK_DETAIL_ITEM_SEARCH_APPLY_OPTION_ERROR:
      return {
        ...state,
        search:{
          ...state.search,
          apply_option:{
            ...state.search.apply_option,
            loading: false,
            list:[],
            message: 'No se encotraron datos'
          }
        }
      }
    case EQUIPMENT_STOCK_DETAIL_ITEM_SEARCH_EQUIPMENT_FILE:
      return {
        ...state,
        search:{
          ...state.search,
          init:false,
          equipment_file:{
            ...state.search.equipment_file,
            loading: true,
            list:[],
            message: ''
          }
        }
      }
    case EQUIPMENT_STOCK_DETAIL_ITEM_SEARCH_EQUIPMENT_FILE_SUCCESS:
      return {
        ...state,
        search:{
          ...state.search,
          equipment_file:{
            ...state.search.equipment_file,
            loading: false,
            list: action.payload,
            message: ''
          }
        }
      }
    case EQUIPMENT_STOCK_DETAIL_ITEM_SEARCH_EQUIPMENT_FILE_ERROR:
      return {
        ...state,
        search:{
          ...state.search,
          equipment_file:{
            ...state.search.equipment_file,
            loading: false,
            list:[],
            message: 'No se encotraron datos'
          }
        }
      }
    case EQUIPMENT_STOCK_DETAIL_ITEM_SEARCH_ACQUISITION_MODE:
      return {
        ...state,
        search:{
          ...state.search,
          init:false,
          acquisition_mode:{
            ...state.search.acquisition_mode,
            loading: true,
            list:[],
            message: ''
          }
        }
      }
    case EQUIPMENT_STOCK_DETAIL_ITEM_SEARCH_ACQUISITION_MODE_SUCCESS:
      return {
        ...state,
        search:{
          ...state.search,
          acquisition_mode:{
            ...state.search.acquisition_mode,
            loading: false,
            list: action.payload,
            message: ''
          }
        }
      }
    case EQUIPMENT_STOCK_DETAIL_ITEM_SEARCH_ACQUISITION_MODE_ERROR:
      return {
        ...state,
        search:{
          ...state.search,
          acquisition_mode:{
            ...state.search.acquisition_mode,
            loading: false,
            list:[],
            message: 'No se encotraron datos'
          }
        }
      }
    case EQUIPMENT_STOCK_DETAIL_ITEM_SEARCH_INSTALLATION_CONDITION:
      return {
        ...state,
        search:{
          ...state.search,
          init:false,
          installation_condition:{
            ...state.search.installation_condition,
            loading: true,
            list:[],
            message: ''
          }
        }
      }
    case EQUIPMENT_STOCK_DETAIL_ITEM_SEARCH_INSTALLATION_CONDITION_SUCCESS:
      return {
        ...state,
        search:{
          ...state.search,
          installation_condition:{
            ...state.search.installation_condition,
            loading: false,
            list: action.payload,
            message: ''
          }
        }
      }
    case EQUIPMENT_STOCK_DETAIL_ITEM_SEARCH_INSTALLATION_CONDITION_ERROR:
      return {
        ...state,
        search:{
          ...state.search,
          installation_condition:{
            ...state.search.installation_condition,
            loading: false,
            list:[],
            message: 'No se encotraron datos'
          }
        }
      }
    case EQUIPMENT_STOCK_DETAIL_ITEM_SEARCH_SERVICE_TYPE:
      return {
        ...state,
        search:{
          ...state.search,
          init:false,
          service_type:{
            ...state.search.service_type,
            loading: true,
            list:[],
            message: ''
          }
        }
      }
    case EQUIPMENT_STOCK_DETAIL_ITEM_SEARCH_SERVICE_TYPE_SUCCESS:
      return {
        ...state,
        search:{
          ...state.search,
          service_type:{
            ...state.search.service_type,
            loading: false,
            list: action.payload,
            message: ''
          }
        }
      }
    case EQUIPMENT_STOCK_DETAIL_ITEM_SEARCH_SERVICE_TYPE_ERROR:
      return {
        ...state,
        search:{
          ...state.search,
          service_type:{
            ...state.search.service_type,
            loading: false,
            list:[],
            message: 'No se encotraron datos'
          }
        }
      }
    case EQUIPMENT_STOCK_DETAIL_ITEM_ADD_CHANGE:
      return {
        ...state,
        add: {
          ...state.add,
          data: {
            ...state.add.data,
            new: {
              ...state.add.data.new,
              ...action.payload
            }
          }
        }
      }
    case EQUIPMENT_STOCK_DETAIL_ITEM_ADD_SET:
      return {
        ...state,
        add: {
          ...state.add,
          data: action.payload
        }
      }
    case EQUIPMENT_STOCK_DETAIL_ITEM_ADD_MODAL_SET:
      return {
        ...state,
        add: {
          ...state.add,
          data: { 
            ...state.add.data,
            new: { id_equipment_stock_detail: null, equipment_stock_detail: null, id_operation_status: null, operation_status: null, id_apply_option: null, apply_option: null, reference: '', observation: '', description: '' }
          },
          modal: action.payload
        }
      }
    case EQUIPMENT_STOCK_DETAIL_ITEM_ADD:
      return {
        ...state,
        add: {
          ...state.add, 
          loading: true
        }
      }
    case EQUIPMENT_STOCK_DETAIL_ITEM_ADD_SUCCESS:
      return {
        ...state,
        add: {
          ...state.add,
          modal: false,
          loading: false,
          message: action.payload.message,
          id: action.payload.id
        }
      }
    case EQUIPMENT_STOCK_DETAIL_ITEM_ADD_ERROR:
      return {
        ...state,
        add: {
          ...state.add,
          loading: false,
          message: action.payload.message
        }
      }
    case EQUIPMENT_STOCK_DETAIL_ITEM_DETAIL:
      return {
        ...state,
        detail: {
          ...state.detail,
          loading: true
        }
      }
    case EQUIPMENT_STOCK_DETAIL_ITEM_DETAIL_SUCCESS:
      return {
        ...state,
        detail: {
          ...state.detail,
          loading: false,
          data: action.payload
        },
        edit: {
          ...state.edit,
          loading: false,
          data: {
            new: action.payload,
            old: action.payload
          }
        }
      }
    case EQUIPMENT_STOCK_DETAIL_ITEM_DETAIL_ERROR:
      return {
        ...state,
        detail: {
          ...state.detail,
          loading: false
        }
      }
    case EQUIPMENT_STOCK_DETAIL_ITEM_VIEW_MODAL_SET:
      return {
        ...state,
        view: {
          ...state.view,
          modal: action.payload
        }
      }
    case EQUIPMENT_STOCK_DETAIL_ITEM_EDIT_MODAL_SET:
      return {
        ...state,
        edit: {
          ...state.edit,
          modal: action.payload
        }
      }
    case EQUIPMENT_STOCK_DETAIL_ITEM_EDIT_CHANGE:
      return {
        ...state,
        edit: {
          ...state.edit,
          data: {
            ...state.edit.data,
            new: {
              ...state.edit.data.new,
              ...action.payload
            }
          }
        }
      }
    case EQUIPMENT_STOCK_DETAIL_ITEM_UPDATE:
      return {
        ...state,
        edit: {
          ...state.edit,
          data: {
            ...state.edit.data,
            ...action.payload,
          },
          update: {
            ...state.update,
            loading: true,
            response: '',
            message: ''
          }
        }
      }
    case EQUIPMENT_STOCK_DETAIL_ITEM_UPDATE_SUCCESS:
      return {
        ...state,
        edit: { 
          ...state.edit,
          modal: false,
          data: {
            ...state.edit.data,
            new: {
              ...state.edit.data.new,
              update_reason: ''
            },
            old: {
              ...state.edit.data.new,
              update_reason: ''
            }
          },
          update: {
            ...state.update,
            loading: false,
            response: 'success',
            message: action.payload
          }
        },
        view: {
          ...state.view,
          modal: false
        }
      }
    case EQUIPMENT_STOCK_DETAIL_ITEM_UPDATE_ERROR:
      return {
        ...state,
        edit: {
          ...state.edit,
          update: {
            ...state.update,
            loading: false,
            response: 'error',
            message: action.payload
          }
        }
      }
    case EQUIPMENT_STOCK_DETAIL_ITEM_VIEW_TAB_SET:
      return {
        ...state,
        view: {
          ...state.view,
          tab: action.payload
        }
      }
    default:
      return { ...state };
    }

};